export default __webpack_public_path__ + "static/404-181c5a6430bcb77324b13a6776d7fc60.gif";